import axios from 'axios';
import React, { useEffect, useState } from 'react';
import './style.css';
import { useNavigate, useParams } from 'react-router-dom';

export default function Queue({ service }) {
    const { uker, code } = useParams();

    const navigate = useNavigate();

    const overlayStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: 'url(../assets/logo/logo-kejati.png)', // Adjust path as needed
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        opacity: 0.1,
        pointerEvents: 'none',
    };

    const [unitKerja, setUnitKerja] = useState(null);
    const [nomorAntrian, setNomorAntrian] = useState(1);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_UKER = "api/kejati/reservation/subprojectdetail";
    const PATH_QUEUE = "api/kejati/mkios/queue";


    const fetchData = async (url, headers) => {
        try {
            const response = await axios.get(url, { headers });
            return response.data;
        } catch (err) {
            // setError("Gagal memuat data. Silakan coba lagi.");
            return null;
        }
    };

    const storeQueue = async () => {
        // setLoading(true);
        try {
            const resp = await axios.post(`${BASE_URL}${PATH_QUEUE}`, {
                unit_kerja: uker,
                number: nomorAntrian,
                service: service,
                code
            });

            // Jika respons berhasil
            if (resp.status === 200 || resp.status === 201) {
                const successResponse = resp.data;

                if (successResponse.action === "RELOAD") {
                    navigate(`/mkios/${uker}`);
                } else {
                    navigate(successResponse.to);
                }
            }
        } catch (err) {
            // setError(err);
        } finally {
            setLoading(false);
            fetchData();
        }
    };

    useEffect(() => {
        if (uker == null) {
            navigate(`/mkios`);
        }

        fetchData(`${BASE_URL}${PATH_UKER}?uker=${uker}`).then((response) => {
            setUnitKerja(response);
        }).finally(() => {
            setLoading(false);
        });

        fetchData(`${BASE_URL}${PATH_QUEUE}?unit_kerja=${uker}`).then((response) => {
            setNomorAntrian(response.number);
        }).finally(() => {
            setLoading(false);
        });

        
    }, [uker]);

    const handlePrint = () => {

        const printContent = document.getElementById("printContent").innerHTML;

        // Create an invisible iframe
        const iframe = document.createElement("iframe");
        iframe.style.position = "absolute";
        iframe.style.top = "-1000px"; // Hide it off-screen
        document.body.appendChild(iframe);

        const doc = iframe.contentWindow.document;
        doc.open();
        doc.write(`
            <html>
            <head>
                <title>Queue Print</title>
                <style>
                    body {
                        font-family: 'Courier New', Courier, monospace;
                        font-size: 12px;
                        margin: 0;
                        padding: 0;
                    }
                    #printContent {
                        width: 2.5in;
                        margin: 0 auto;
                        text-align: center;
                    }
                    .queue-number {
                        font-size: 2rem;
                        color: #000;
                        background-color: transparent;
                        margin: 0;
                    }
                </style>
            </head>
            <body>
                <div id="printContent">${printContent}</div>
            </body>
            </html>
        `);
        doc.close();

        // Wait for the iframe content to be fully loaded before printing
        iframe.onload = () => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();

            // Remove iframe after a short delay to allow print dialog to open
            setTimeout(() => {
                document.body.removeChild(iframe);
                storeQueue(); // Ensure this runs after print completes
            }, 500);
        };
    };

    if (loading) {
        return (
            <div className="loading-container">
                <div className="spinner"></div>
                <p>Loading...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="error-container">
                <p className="error-message">Error: {error.message}</p>
            </div>
        );
    }

    return (
        <div className="queue-container">
            <div style={overlayStyle}></div>
            <header className="queue-header">
                <h1 className='font-bold'>
                    Halaman Antrian <span className='font-extralight'>{unitKerja?.name}</span>
                </h1>
                <h1 className='font-bold text-black-50'>{service}</h1>
                <div className="queue-info" id="printContent">
                    <h2 className='font-bold'>Nomor Antrian</h2>
                    <div className="queue-number">{nomorAntrian}</div>

                    <hr />

                    <h2 className='font-bold'>Layanan</h2>
                    <p >{service}</p>
                </div>
                <input type='hidden' value={service} className='my-3 p-2 block text-black w-full border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200' />
                <button className="print-button" onClick={handlePrint}>Ambil Nomor Antrian</button>
            </header>
        </div>
    );
}
